import { DEVICE_BREAKPOINT } from 'Shared/styles/designConstants';
import styled, { keyframes } from 'styled-components';

export const FixedContainer = styled.div`
  position: fixed;
  bottom  : 30px;
  right   : 30px;
  z-index : 9995;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    bottom: 15px;
    right : 15px;
  }
`;

export const StyledLauncher = styled.button`
  align-items     : center;
  border-radius   : 34px 8px 34px 34px;
  box-shadow      : 0 5px 4px 0 rgba(0, 0, 0, .26);
  color           : #fff;
  cursor          : pointer;
  display         : flex;
  justify-content : center;
  height          : 60px;
  width           : 60px;
  background-color: #3e761b !important;
  border          : none;
  outline         : none;
  padding         : 0;
  position        : relative;
  transition      : transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    height       : 48px;
    width        : 48px;
    border-radius: 27px 6px 27px 27px;
  }
`;

export const ChatIcon = styled.div`
  background-color: #fff;
  border-radius   : 6px 6px 6px 2px;
  height          : 17px;
  left            : 32%;
  position        : absolute;
  top             : 37%;
  width           : 38%;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    height: 14px;
    top   : 36%;
  }

  &::before {
    border-radius   : 2px 2px 2px 2px;
    content         : "";
    height          : 2px;
    left            : 4px;
    position        : absolute;
    top             : 5px;
    width           : 65%;
    background-color: #3e761b !important;

    @media ${DEVICE_BREAKPOINT.maxMobile} {
      height: 1.5px;
      top   : 4px;
      left  : 3px;
      width : 65%;
    }
  }

  &::after {
    border-radius   : 2px 2px 2px 2px;
    content         : "";
    height          : 2px;
    left            : 4px;
    position        : absolute;
    top             : 10px;
    width           : 44%;
    background-color: #3e761b !important;

    @media ${DEVICE_BREAKPOINT.maxMobile} {
      height: 1.5px;
      top   : 8px;
      left  : 3px;
      width : 44%;
    }
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border       : 3px solid rgba(255, 255, 255, 0.3);
  border-top   : 3px solid #fff;
  border-radius: 50%;
  width        : 24px;
  height       : 24px;
  animation    : ${spin} 1s linear infinite;
`;
